export default {
  choose: {
    title: 'Quitar a {{name}} como propietario',
    title_no_owner: 'Elige un propietario para {{restaurant}}',
    description: 'Elige quién releva a {{name}}, o deja {{restaurant}} sin propietario por ahora.',
    description_no_owner: '{{restaurant}} no tiene propietario. Elige a alguien del equipo o a una persona nueva.',
    new_owner: 'Nuevo propietario',
    previous_owner: '{{name}} tras el cambio',
  },
  options: {
    team: {
      title: 'Alguien del equipo',
      loading: 'Cargando el equipo…',
      description_one: 'Cualquier operador o empleado, {{count}} persona.',
      description_other: 'Cualquier operador o empleado, {{count}} personas.',
      empty: 'Todavía no hay nadie más en el equipo.',
      search: 'Busca en el equipo por nombre o correo',
      no_match: 'Nadie del equipo coincide con «{{query}}».',
    },
    new: {
      title: 'Alguien nuevo',
      description: 'Será propietario de inmediato y recibirá sus credenciales por correo.',
    },
    none: {
      title: 'Sin propietario por ahora',
      description: 'Elige un propietario más tarde. Hasta entonces, {{restaurant}} no tiene propietario.',
    },
    keep: {
      title: 'Sigue en el equipo como operador',
      description: 'Mantiene el acceso a los restaurantes que gestiona hoy.',
    },
    remove: {
      title: 'Se elimina del equipo',
      description: 'Pierde el acceso al panel de inmediato.',
    },
  },
  roles: {
    operator: 'Operador',
    employee: 'Empleado',
  },
  fields: {
    first_name: 'Nombre',
    last_name: 'Apellidos',
    email: 'Correo electrónico',
  },
  email_errors: {
    invalid_email: 'Introduce un correo válido, como nombre@ejemplo.com.',
    email_is_owner: '{{name}} ya es el propietario.',
    email_is_manager: '{{name}} ya está en el equipo.',
    email_taken: 'Alguien ajeno a este equipo ya inicia sesión con este correo. Usa otro correo.',
  },
  confirm: {
    title: '¿Quitar a {{name}} como propietario?',
    title_no_owner: '¿Hacer a {{name}} propietario?',
    description_both: 'Ambos cambios se aplican a la vez. Si uno falla, no cambia nada.',
    description: 'Revisa el cambio antes de confirmar.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> no tendrá propietario hasta que elijas uno. Todo lo que requiera al propietario queda en espera.',
    new: '<b>{{name}}</b> pasa a ser propietario de {{restaurant}} de inmediato.',
    email:
      'Sus credenciales se envían a <b>{{email}}</b>. Compruébalo: quien tenga este correo podrá iniciar sesión como propietario.',
    team: '<b>{{name}}</b> pasa a ser propietario de {{restaurant}}.',
    group_access:
      'Como propietario tendrá acceso a todos los restaurantes de {{group}}, que pueden ser más de los que tiene hoy.',
    keep: '<b>{{name}}</b> sigue en el equipo como operador.',
    remove: '<b>{{name}}</b> se elimina del equipo y ya no podrá iniciar sesión.',
  },
  error: {
    title: 'No se pudo cambiar el propietario.',
    description: 'No se cambió nada. Inténtalo de nuevo o contacta con soporte si sigue fallando.',
  },
  buttons: {
    close: 'Cerrar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    back: 'Atrás',
    remove_as_owner: 'Quitar como propietario',
    make_owner: 'Hacer propietario',
    saving: 'Guardando…',
    try_again: 'Reintentar',
    choose_instead: 'Elegir a {{name}} en su lugar',
    invite_instead: 'Invitar a alguien nuevo',
  },
};
